import React from "react";


import img1 from "../../media/images/delhi.png"
import img2 from "../../media/images/noida.png"
import img3 from "../../media/images/greater-noida.png"
import img4 from "../../media/images/gurgaon.png"
import img5 from "../../media/images/ghaziabad.png"
import img6 from "../../media/images/faridabad.png"


import { useSelector, useDispatch } from "react-redux";
import { setCityName } from "../../store/citySlice";

function ChooseLocation({ setChooseLocation, setCartList  }) {

  // const cityName = useSelector((state) => state.city.cityName);



  const cityName  = useSelector((state)=>state.city.cityName);
  const dispatch = useDispatch();



  // console.log("cyrrent-cityName", cityName);

  const handleSetCityToNoida = () => {
    dispatch(setCityName("Noida"));
    setChooseLocation(false);
    setCartList(true);
  };


    const handleSetCityToDelhi = () => {
    dispatch(setCityName("Delhi"));
    setChooseLocation(false);
    setCartList(true);
  };


    const handleSetCityToGNoida = () => {
    dispatch(setCityName("Greater Noida"));
    setChooseLocation(false);
    setCartList(true);
  };

    const handleSetCityToGurgaon = () => {
    dispatch(setCityName("Gurgaon"));
    setChooseLocation(false);
    setCartList(true);
  };
  

 const handleSetCityToGhaziabad= () => {
    dispatch(setCityName("Ghaziabad"));
    setChooseLocation(false);
    setCartList(true);
  };


 const handleSetCityToFaridabad= () => {
    dispatch(setCityName("Faridabad"));
    setChooseLocation(false);
    setCartList(true);
  };

   const handleSetCityToChandigarh= () => {
    dispatch(setCityName("Chandigarh"));
    setChooseLocation(false);
    setCartList(true);
  };

  const handleSetCityToOthers= () => {
    dispatch(setCityName("Others"));
    setChooseLocation(false);
    setCartList(true);
  };

  
  

  return (
    
    <div className="choose-main-location-sectionCard">

    <div className="choose-location-sectionCard">
      

      <div className="choose-location-sectionCard-content"> 
      <div className="choose-location-sectionCard-heading">
        Select Your Location   <i class="fa-solid fa-location-dot"></i>
      </div>


<div className="choose-location-sectionCard-heading-row">

  <div className="choose-location-sectionCard-heading-cols" onClick={handleSetCityToDelhi}>
    <div className="choose-location-sec-card-img"> <img src={img1} alt="delhi"></img></div>
    Delhi</div>
   <div className="choose-location-sectionCard-heading-cols" onClick={handleSetCityToNoida}>
        <div className="choose-location-sec-card-img"> <img src={img2} alt="noida"></img></div>

    Noida
    </div>
  <div className="choose-location-sectionCard-heading-cols"  onClick={handleSetCityToGNoida}>
        <div className="choose-location-sec-card-img"> <img src={img3} alt="gnoida"></img></div>
  Greater Noida
    </div>
  <div className="choose-location-sectionCard-heading-cols"  onClick={handleSetCityToGurgaon} >
        <div className="choose-location-sec-card-img"> <img src={img4} alt="gurgaon"></img></div>

    Gurgaon</div>
  <div className="choose-location-sectionCard-heading-cols" onClick={handleSetCityToGhaziabad} >
        <div className="choose-location-sec-card-img"> <img src={img5} alt="ghaziabad"></img></div>

 Ghaziabad
    </div>
  <div className="choose-location-sectionCard-heading-cols" onClick={handleSetCityToFaridabad} >
        <div className="choose-location-sec-card-img"> <img src={img6} alt="frida_01"></img></div>

  Faridabad
    </div>

      {/* <div className="choose-location-sectionCard-heading-cols" onClick={handleSetCityToChandigarh} >
        <div className="choose-location-sec-card-img"> <img src={img6} alt="chnd"></img></div>
        Chandigarh
    </div>

  <div className="choose-location-sectionCard-heading-cols" onClick={handleSetCityToOthers} >
        <div className="choose-location-sec-card-img"> <img src={img1} alt="others"></img></div>

    Others
    </div> */}


</div>



      </div>
    </div>
    </div>
  );
}

export default ChooseLocation;
